import { useEffect, useRef } from 'react';
import { Typography } from '@mui/material';

const Title = ({ autoFocus = true, ...props }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      titleRef.current?.focus({ focusVisible: true });
    }
  }, [autoFocus]);

  return (
    <Typography
      ref={titleRef}
      tabIndex={0}
      variant='h3'
      component='h1'
      mb={{ xs: 2, sm: 3 }}
      fontSize={{ xs: '1.7rem', sm: '3rem' }}
      textAlign={{ xs: 'center', sm: 'left' }}
      sx={{
        '&:focus-visible': {
          outline: 'none',
        },
      }}
      {...props}
    >
      {props.text}
      {props.children}
    </Typography>
  );
};

export default Title;
